import { analytics } from 'moet-core';

export const ANALYTICS_EVENTS = {
  preAssessmentNewCase: new analytics.Event({
    name: 'Pre-assessment Case Submitted',
    description:
      'Sales representative opens a new pre-assessment case for an already submitted one',
    action: analytics.EVENT_ACTION.FORM_SUBMIT,
    category: analytics.EVENT_CATEGORY.FLOW_STEP,
    type: analytics.EVENT_TYPE.USER_PREFERENCE,
    properties: [],
  }),
};
